export const translations = {
  bn: {
    // General
    appTitle: 'বাংলাদেশ ভূমি সেবা',
    appTitleShort: 'ভূমি সেবা',
    login: 'লগইন',
    logout: 'লগআউট',
    language: 'English',
    search: 'অনুসন্ধান',
    save: 'সংরক্ষণ করুন',
    cancel: 'বাতিল',
    viewDetails: 'বিস্তারিত দেখুন',
    download: 'ডাউনলোড',
    print: 'প্রিন্ট',
    verify: 'যাচাই করুন',
    apply: 'আবেদন করুন',
    status: 'অবস্থা',
    date: 'তারিখ',

    // Navigation
    navDashboard: 'ড্যাশবোর্ড',
    navSearch: 'অনুসন্ধান',
    navMyPlots: 'আমার প্লট',
    navServices: 'সেবাসমূহ',
    navMap: 'মানচিত্র',
    navReports: 'প্রতিবেদন',
    navNotifications: 'বিজ্ঞপ্তি',
    navProfile: 'প্রোফাইল',

    // Dashboard
    dashLinkedPlots: 'সংযুক্ত প্লট',
    dashActiveCLOs: 'সক্রিয় সিএলও',
    dashPendingMutation: 'অপেক্ষমাণ নামজারি',
    dashTaxDue: 'বকেয়া কর',
    dashDisputed: 'বিরোধপূর্ণ প্লট',
    dashRecentApps: 'সাম্প্রতিক আবেদনসমূহ',
    dashQuickActions: 'দ্রুত পদক্ষেপ',
    dashReportSummary: 'প্রতিবেদন সারসংক্ষেপ',

    // Land Terms
    district: 'জেলা',
    upazila: 'উপজেলা',
    mouza: 'মৌজা',
    khatian: 'খতিয়ান',
    dag: 'দাগ',
    plotName: 'প্লটের নাম',
    landType: 'জমির ধরন',
    area: 'পরিমাণ (শতাংশ)',
    ownershipType: 'মালিকানার ধরন',
    mutationStatus: 'নামজারি অবস্থা',
    taxStatus: 'ভূমি কর অবস্থা',

    // Status Values
    completed: 'সম্পন্ন',
    pending: 'অপেক্ষমাণ',
    paid: 'পরিশোধিত',
    due: 'বকেয়া',
    sole: 'একক',
    joint: 'যৌথ',
    agricultural: 'কৃষি',
    residential: 'আবাসিক',
    commercial: 'বাণিজ্যিক',

    // Plot Details
    tabOverview: 'সারসংক্ষেপ',
    tabCLO: 'সিএলও',
    tabDocuments: 'নথিপত্র',
    tabMutation: 'নামজারি তথ্য',
    tabTax: 'এলডি ট্যাক্স তথ্য',
    tabDisputes: 'মামলা তথ্য',
    tabMortgages: 'বন্ধক তথ্য',
    tabParcelMap: 'পার্সেল মানচিত্র',
    tabTransferHistory: 'হস্তান্তর বৃত্তান্ত',

    // Detailed Info Headers
    transferHistory: 'হস্তান্তর বৃত্তান্ত',
    transferDate: 'হস্তান্তরের তারিখ',
    transferFrom: 'হস্তান্তরকারী',
    transferTo: 'গ্রহীতা',
    transferType: 'হস্তান্তরের ধরন',
    dolilNo: 'দলিল নম্বর',
    dolilDate: 'দলিলের তারিখ',
    docRef: 'দলিল নম্বর',
    mutCaseNo: 'মামলা নম্বর',
    mutCaseDate: 'মামলার তারিখ',
    approvalDate: 'অনুমোদনের তারিখ',
    dcrNo: 'ডিসিআর নম্বর',
    dcrDate: 'ডিসিআর তারিখ',
    prevKhatianNo: 'আগত খতিয়ান নং',
    dagLandArea: 'দাগে জমির পরিমান (একর)',
    khatianLandArea: 'খতিয়ানে জমির পরিমাণ (একর)',
    transferredLandArea: 'হস্তান্তরিত জমির পরিমাণ (একর)',
    ownershipSource: 'মালিকানা সূত্র',
    descriptionLabel: 'বিবরণ',
    transferStatement: 'হস্তান্তর বৃত্তান্ত',

    ldTaxHistory: 'এলডি ট্যাক্স তথ্য',
    taxYear: 'অর্থবছর',
    amount: 'পরিমাণ',
    dhakhilaNo: 'দাখিলা নম্বর',
    dhakhilaDate: 'দাখিলার তারিখ',
    receiptNo: 'রসিদ নম্বর',
    paymentDate: 'প্রদানের তারিখ',

    litigations: 'মামলা তথ্য',
    caseInfo: 'মামলা তথ্য',
    caseNo: 'মামলা নম্বর',
    court: 'আদালত',
    plaintiff: 'বাদী',
    defendant: 'বিবাদী',
    dateFiled: 'দায়েরের তারিখ',

    mortgages: 'বন্ধক তথ্য',
    mortgagesInfo: 'বন্ধক তথ্য',
    khatianDetails: 'খতিয়ান বিবরণ',
    surveyType: 'সার্ভে ধরন',
    ownerName: 'মালিকের নাম',
    fatherName: 'পিতার নাম',
    address: 'ঠিকানা',
    surveyName: 'সার্ভের নাম',
    cloNo: 'সিএলও নম্বর',
    parcelMap: 'পার্সেল মানচিত্র',
    applyCLO: 'সিএলও সনদের জন্য আবেদন করুন',
    paymentProcessing: 'পেমেন্ট প্রক্রিয়াকরণ',
    payNow: 'এখনই পরিশোধ করুন',
    paymentSuccess: 'পেমেন্ট সফল হয়েছে',
    viewCLOCertificate: 'সিএলও সনদ দেখুন',
    cloFee: 'সিএলও ফি',
    bankName: 'ব্যাংকের নাম',
    loanAmount: 'ঋণের পরিমাণ',
    mortgageDate: 'বন্ধকের তারিখ',
    releaseDate: 'অবমুক্তির তারিখ',
    active: 'সক্রিয়',
    released: 'অবমুক্ত',
    noRecordFound: 'কোন রেকর্ড পাওয়া যায়নি',

    // Actions
    createRecord: 'নতুন রেকর্ড তৈরি করুন',
    payTax: 'কর প্রদান করুন',
    applyMutation: 'নামজারির আবেদন',
    downloadCLO: 'সিএলও ডাউনলোড',
    verifyCLO: 'সিএলও যাচাই',
    uploadDoc: 'নথি আপলোড করুন',

    // Auth
    enterMobileNID: 'মোবাইল নম্বর বা এনআইডি দিন',
    getOTP: 'ওটিপি পান',
    enterOTP: 'ওটিপি দিন',
    verifyLogin: 'যাচাই ও লগইন',

    // Home
    heroTitle: 'আপনার ভূমির অধিকার, এখন আপনার হাতের মুঠোয়',
    heroSubtitle:
      'প্লট-ভিত্তিক সিএলও (সার্টিফিকেট অফ ল্যান্ড ওনারশিপ) এর মাধ্যমে আপনার জমির সমস্ত তথ্য এক জায়গায় সুরক্ষিত ও পরিচালিত করুন।',
    getStarted: 'শুরু করুন',
    learnMore: 'আরও জানুন',

    // Public Home & Map
    publicHome: 'প্রধান পাতা',
    mouzaMap: 'মৌজা মানচিত্র',
    ministryName: 'ভূমি মন্ত্রণালয়',
    govName: 'গণপ্রজাতন্ত্রী বাংলাদেশ সরকার',
    selectDistrict: 'জেলা নির্বাচন করুন',
    selectUpazila: 'উপজেলা নির্বাচন করুন',
    selectMouza: 'মৌজা নির্বাচন করুন',
    searchByKhatian: 'খতিয়ান নম্বর দিয়ে অনুসন্ধান',
    searchByDag: 'দাগ নম্বর দিয়ে অনুসন্ধান',
    applyFilter: 'ফিল্টার প্রয়োগ করুন',
    resetFilter: 'রিসেট',
    plotDetails: 'প্লট বিবরণ',
    cloDetails: 'সিএলও বিবরণ',
    selectMouzaPrompt: 'প্লট দেখতে একটি মৌজা নির্বাচন করুন',
    totalPlotsDigitized: 'মোট ডিজিটাইজড প্লট',
    closIssued: 'সিএলও ইস্যুকৃত',
    mutationsCompleted: 'নামজারি সম্পন্ন',
    districtsCovered: 'জেলা কভারেজ',
    recentNotices: 'সাম্প্রতিক বিজ্ঞপ্তি',
    quickServices: 'দ্রুত সেবা',
    viewOnMap: 'মানচিত্রে দেখুন',
    cloInfo: 'সিএলও তথ্য',
    ownerInfo: 'মালিকের তথ্য',
    locationInfo: 'অবস্থান তথ্য',
    viewFullCLO: 'সম্পূর্ণ সিএলও দেখুন',
    legend: 'নির্দেশিকা',
    searchPlaceholder: 'খতিয়ান / দাগ / প্লট আইডি দিয়ে খুঁজুন...',
    searchButton: 'খুঁজুন',
    notice1: 'ভূমি উন্নয়ন কর পরিশোধের সময়সীমা বৃদ্ধি করা হয়েছে।',
    notice2: 'নতুন ই-নামজারি সিস্টেম চালু হয়েছে।',
    notice3: 'ডিজিটাল রেকর্ড রুম সেবা এখন সকল জেলায় উন্মুক্ত।',
    usefulLinks: 'প্রয়োজনীয় লিংক',
    contactInfo: 'যোগাযোগ',
    copyright:
      '© ২০২৬ ভূমি মন্ত্রণালয়, গণপ্রজাতন্ত্রী বাংলাদেশ সরকার। সর্বস্বত্ব সংরক্ষিত।',
  },
  en: {
    // General
    appTitle: 'Bangladesh Land Service',
    appTitleShort: 'Land Service',
    login: 'Login',
    logout: 'Logout',
    language: 'বাংলা',
    search: 'Search',
    save: 'Save',
    cancel: 'Cancel',
    viewDetails: 'View Details',
    download: 'Download',
    print: 'Print',
    verify: 'Verify',
    apply: 'Apply',
    status: 'Status',
    date: 'Date',

    // Navigation
    navDashboard: 'Dashboard',
    navSearch: 'Search',
    navMyPlots: 'My Plots',
    navServices: 'Services',
    navMap: 'Map',
    navReports: 'Reports',
    navNotifications: 'Notifications',
    navProfile: 'Profile',

    // Dashboard
    dashLinkedPlots: 'Linked Plots',
    dashActiveCLOs: 'Active CLOs',
    dashPendingMutation: 'Pending Mutation',
    dashTaxDue: 'Tax Due',
    dashDisputed: 'Disputed Plots',
    dashRecentApps: 'Recent Applications',
    dashQuickActions: 'Quick Actions',
    dashReportSummary: 'Report Summary',

    // Land Terms
    district: 'District',
    upazila: 'Upazila',
    mouza: 'Mouza',
    khatian: 'Khatian',
    dag: 'Dag',
    plotName: 'Plot Name',
    landType: 'Land Type',
    area: 'Area (Decimals)',
    ownershipType: 'Ownership Type',
    mutationStatus: 'Mutation Status',
    taxStatus: 'Tax Status',

    // Status Values
    completed: 'Completed',
    pending: 'Pending',
    paid: 'Paid',
    due: 'Due',
    sole: 'Sole',
    joint: 'Joint',
    agricultural: 'Agricultural',
    residential: 'Residential',
    commercial: 'Commercial',

    // Plot Details
    tabOverview: 'Overview',
    tabCLO: 'CLO',
    tabDocuments: 'Documents',
    tabMutation: 'Mutation Info',
    tabTax: 'LD TAX Info',
    tabDisputes: 'Case Info',
    tabMortgages: 'Mortgages Info',
    tabParcelMap: 'Parcel Map',
    tabTransferHistory: 'Transfer History',

    // Detailed Info Headers
    transferHistory: 'Transfer History',
    transferDate: 'Transfer Date',
    transferFrom: 'From (Transferor)',
    transferTo: 'To (Transferee)',
    transferType: 'Transfer Type',
    dolilNo: 'Dolil No.',
    dolilDate: 'Dolil Date',
    docRef: 'Document Ref.',
    mutCaseNo: 'Case No.',
    mutCaseDate: 'Case Date',
    approvalDate: 'Approval Date',
    dcrNo: 'DCR No.',
    dcrDate: 'DCR Date',
    prevKhatianNo: 'Previous Khatian No.',
    dagLandArea: 'Land Area in Dag (Acres)',
    khatianLandArea: 'Land Area in Khatian (Acres)',
    transferredLandArea: 'Transferred Land Area (Acres)',
    ownershipSource: 'Ownership Source',
    descriptionLabel: 'Description',
    transferStatement: 'Transfer History',

    ldTaxHistory: 'LD TAX Info',
    taxYear: 'Fiscal Year',
    amount: 'Amount',
    dhakhilaNo: 'Dhakhila No.',
    dhakhilaDate: 'Dhakhila Date',
    receiptNo: 'Receipt No.',
    paymentDate: 'Payment Date',

    litigations: 'Case Info',
    caseInfo: 'Case Info',
    caseNo: 'Case No.',
    court: 'Court',
    plaintiff: 'Plaintiff',
    defendant: 'Defendant',
    dateFiled: 'Date Filed',

    mortgages: 'Mortgages Info',
    mortgagesInfo: 'Mortgages Info',
    khatianDetails: 'Khatian Details',
    surveyType: 'Survey Type',
    ownerName: 'Owner Name',
    fatherName: 'Father Name',
    address: 'Address',
    surveyName: 'Survey Name',
    cloNo: 'CLO No.',
    parcelMap: 'Parcel Map',
    applyCLO: 'Apply for CLO Certificate',
    paymentProcessing: 'Payment Processing',
    payNow: 'Pay Now',
    paymentSuccess: 'Payment Successful',
    viewCLOCertificate: 'View CLO Certificate',
    cloFee: 'CLO Fee',
    bankName: 'Bank/Institution',
    loanAmount: 'Loan Amount',
    mortgageDate: 'Mortgage Date',
    releaseDate: 'Release Date',
    active: 'Active',
    released: 'Released',
    noRecordFound: 'No records found',

    // Actions
    createRecord: 'Create New Record',
    payTax: 'Pay Tax',
    applyMutation: 'Apply Mutation',
    downloadCLO: 'Download CLO',
    verifyCLO: 'Verify CLO',
    uploadDoc: 'Upload Document',

    // Auth
    enterMobileNID: 'Enter Mobile or NID',
    getOTP: 'Get OTP',
    enterOTP: 'Enter OTP',
    verifyLogin: 'Verify & Login',

    // Home
    heroTitle: 'Your Land Rights, Now at Your Fingertips',
    heroSubtitle:
      'Secure and manage all your land information in one place through the plot-based CLO (Certificate of Land Ownership) system.',
    getStarted: 'Get Started',
    learnMore: 'Learn More',

    // Public Home & Map
    publicHome: 'Home',
    mouzaMap: 'Mouza Map',
    ministryName: 'Ministry of Land',
    govName: 'Government of Bangladesh',
    selectDistrict: 'Select District',
    selectUpazila: 'Select Upazila',
    selectMouza: 'Select Mouza',
    searchByKhatian: 'Search by Khatian No.',
    searchByDag: 'Search by Dag No.',
    applyFilter: 'Apply Filter',
    resetFilter: 'Reset',
    plotDetails: 'Plot Details',
    cloDetails: 'CLO Details',
    selectMouzaPrompt: 'Select a Mouza to view plots',
    totalPlotsDigitized: 'Total Plots Digitized',
    closIssued: 'CLOs Issued',
    mutationsCompleted: 'Mutations Completed',
    districtsCovered: 'Districts Covered',
    recentNotices: 'Recent Notices',
    quickServices: 'Quick Services',
    viewOnMap: 'View on Map',
    cloInfo: 'CLO Information',
    ownerInfo: 'Owner Information',
    locationInfo: 'Location Information',
    viewFullCLO: 'View Full CLO',
    legend: 'Legend',
    searchPlaceholder: 'Search by Khatian / Dag / Plot ID...',
    searchButton: 'Search',
    notice1: 'Deadline for land development tax payment has been extended.',
    notice2: 'New e-Mutation system has been launched.',
    notice3: 'Digital Record Room service is now open in all districts.',
    usefulLinks: 'Useful Links',
    contactInfo: 'Contact',
    copyright:
      '© 2026 Ministry of Land, Government of Bangladesh. All rights reserved.',
  },
}

export type Language = 'bn' | 'en'
